import { ArrowDown, BookOpen, HeartHandshake } from "lucide-react";

export default function Hero() {
  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="hero__copy reveal" style={{ "--i": 0 }}>
        <p className="hero__status">
          <span aria-hidden="true" /> DNB Psychiatry · Second year
        </p>
        <h1 id="hero-title">A quieter place to understand the mind.</h1>
        <p className="hero__lede">
          I’m Dr. Neerja Gidwani. I’m training in psychiatry and building this space to
          share what I’m learning—in clearer language, with room for questions.
        </p>
        <div className="hero__actions">
          <a className="button button--ink" href="/notes">
            <BookOpen size={18} aria-hidden="true" /> Read my notes
          </a>
          <a className="button button--quiet" href="#tools">
            <HeartHandshake size={18} aria-hidden="true" /> Use a tool
          </a>
        </div>
      </div>

      <figure className="hero-illustration reveal" style={{ "--i": 1 }}>
        <img
          src="/images/illustrations/quiet-attention.jpg"
          alt="An open notebook connected by an ink line to layered paper and a warm doorway"
          width="1448"
          height="1086"
          fetchPriority="high"
        />
        <figcaption>Psychiatry in training · Education in public</figcaption>
      </figure>

      <a className="hero__scroll" href="#about">
        A note from me <ArrowDown size={17} aria-hidden="true" />
      </a>
    </section>
  );
}
